import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { useLanguage } from "../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import { LuTrash2 } from "react-icons/lu";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SettingsContextModal = ({
    account_id,
    show,
    handleClose,
    fetchRecords,
    setContextData,
    contextData,
    setOpenDeleteContext
}) => {

    const { t } = useLanguage()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const handleChange = (e) => {
        setContextData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!contextData.name.trim()) {
            setErrorMessage({ message: t.context.name_required, display: true });
            return;
        }

        if (!contextData.description.trim()) {
            setErrorMessage({ message: t.context.desc_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/update_context`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    context_id: contextData.id,
                    name: contextData.name,
                    description: contextData.description,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                fetchRecords()
                closeModal()
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const handleDelete = () => {
        setOpenDeleteContext(true)
        closeModal()
    }

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.context.update_context_title}</p>
                <button className="context_window_footer_btn_delete fade-in" onClick={handleDelete}><LuTrash2 /></button>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={contextData.name}
                            onChange={handleChange}
                            placeholder={t.context.title_placeholder}
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>

                    <div className="label_input">
                        <label className="input_label">
                            {t.description} <MandatorySign message={t.mandatory_field} />
                        </label>
                        <textarea
                            name="description"
                            maxLength={300}
                            value={contextData.description}
                            onChange={handleChange}
                            placeholder={t.context.description_placeholder}
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>

                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SettingsContextModal;